import { Enumify } from "enumify";
import appleLogo from '@common/assets/images/apple-logo.svg'
import kakaoLogo from '@common/assets/images/kakao-logo.svg'
import kakaoMyPageLogo from '@common/assets/images/kakao_user_logo.svg'
import naverLogo from '@common/assets/images/naver-logo-login.svg'
import googleLogo from '@common/assets/images/google-logo.png'

class SocialLogin extends Enumify {
  static apple = new SocialLogin({
    name: "Apple로 로그인",
    className: 'apple',
    imgClassName: '',
    buttonImage : appleLogo,
    myPageLogo : appleLogo,
    provider:'apple.com'
  });
  static google = new SocialLogin({
    name: "Google로 로그인",
    className: 'google',
    imgClassName: 'google-logo',
    buttonImage : googleLogo,
    myPageLogo:googleLogo,
    provider:'google.com'
  });
  static kakao = new SocialLogin({
    name: "카카오로 로그인",
    className: 'kakao',
    imgClassName: '',
    buttonImage : kakaoLogo,
    myPageLogo:kakaoMyPageLogo
  });
  static naver = new SocialLogin({
    name: "네이버로 로그인",
    className: 'naver',
    imgClassName: '',
    buttonImage : naverLogo
  });
  static _ = this.closeEnum();

  constructor(props) {
    super();
    Object.defineProperties(this, Object.getOwnPropertyDescriptors(props));
  }
}

export default SocialLogin;
